import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  static values = {
    url: String,
    selected: String,
    format: { type: String, default: "default" },
  };

  connect() {
    console.log("SelectController connected");
    const self = this;
    this.select = new TomSelect(this.element, {
      valueField: "id",
      labelField: "text",
      searchField: ["text"],
      load: (query, callback) => {
        console.log("Load triggered with query:", query);
        return this.load(query, callback);
      },
      preload: "focus",
      create: false,
      maxItems: 1,
      closeAfterSelect: true,
      allowEmptyOption: false,
      maxOptions: 50,
      render: {
        option: function (data, escape) {
          console.log("Rendering option:", data);
          return `<div class="py-2 px-3">${escape(data.text)}</div>`;
        },
        item: function (data, escape) {
          console.log("Rendering selected item:", data);
          return `<div class="truncate">${escape(data.text)}</div>`;
        },
        no_results: function (data, escape) {
          console.log("No results to render");
          return '<div class="py-2 px-3">No results found</div>';
        },
      },
      onType: function (str) {
        console.log("onType triggered with:", str);
        if (str.length >= 2) {
          console.log("Loading data for:", str);
          this.load(str);
        }
      },
      onLoad: function (options) {
        console.log("onLoad triggered with options:", options);
      },
      onInitialize: async function () {
        console.log("Select initialized");
        if (self.selectedValue) {
          // await self.loadInitialValue();
        }
      },
      dropdownClass: "ts-dropdown-container",
    });

    // Setup event listeners for debugging
    this.select.on("type", function (str) {
      console.log("Type event:", str);
    });

    this.select.on("load", function (data) {
      console.log("Load event:", data);
    });

    this.select.on("dropdown_open", function () {
      console.log("Dropdown opened");
    });
  }

  disconnect() {
    if (this.select) {
      this.select.destroy();
    }
  }

  formatOptionText(record) {
    console.log("Formatting option text for record:", record);
    let text;
    if (this.formatValue === "organization") {
      if (
        record.attributes.common_name_ancestors !== null &&
        record.attributes.common_name_ancestors.length !== 0
      ) {
        text =
          record.attributes.common_name +
          " (" +
          record.attributes.common_name_ancestors.reverse().join(", ") +
          ")";
      } else {
        text = record.attributes.common_name;
      }
    } else {
      if (
        record.attributes.name_ancestors !== null &&
        record.attributes.name_ancestors.length !== 0
      ) {
        const ancestors = [...record.attributes.name_ancestors];
        if (
          record.attributes.scope &&
          record.attributes.scope.includes("wine_region")
        ) {
          // Remove the country from ancestors for wine regions
          ancestors.pop();
        }
        text =
          record.attributes.name + " (" + ancestors.reverse().join(", ") + ")";
      } else {
        text = record.attributes.name;
      }
    }
    return text;
  }

  async loadInitialValue() {
    try {
      const response = await fetch(
        `${this.urlValue}?filter[id]=${this.selectedValue}`
      );
      const data = await response.json();

      if (data.data && data.data.length > 0) {
        const record = data.data[0];
        const option = {
          id: record.id,
          text: this.formatOptionText(record),
        };
        this.select.addOption(option);
        this.select.setValue(option.id);
      }
    } catch (error) {
      console.error("Error loading initial value:", error);
    }
  }

  async load(query, callback) {
    try {
      let url = new URL(this.urlValue, window.location.origin);

      // Get existing params from the URL
      const params = new URLSearchParams(url.search);

      // Add the search parameter
      if (typeof query === "string") {
        params.append("filter[search]", query);
      }

      // Set the updated search params
      url.search = params.toString();

      const response = await fetch(url);
      const data = await response.json();

      const options = data.data.map((record) => ({
        id: record.id,
        text: this.formatOptionText(record),
      }));

      callback(options);
    } catch (error) {
      console.error("Error loading options:", error);
      callback([]);
    }
  }
}
